export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
// export const SERVER_URL = "https://localhost:44378/";

export const APP_MANAGER_SERVER_URL = process.env.REACT_APP_MANAGER_SERVER_URL;
export const APP_MANAGER_SERVER_SENDSMS_URL =
	process.env.REACT_APP_MANAGER_SERVER_SENDSMS_URL;
export const APP_MANAGER_SERVER_GETSMS_URL =
	process.env.REACT_APP_MANAGER_SERVER_GETSMS_URL;
